export default __webpack_public_path__ + "static/media/330_dummy2016-meditation01-mobile-de.ececf571.png";